import { COMMON_MIXPANEL_PAGE, COMMON_MIXPANEL_PROPERTIES, S4C_PROPERTIES } from '../common/constants/mixpanelConstants'

import type { CarelonDirectoryTrackingConfiguration, CarelonProviderDirectoryFeatureFlagValues } from './types'

export enum CARELON_PROVIDER_DIRECTORY_PLACEMENTS {
  PROVIDER_RESULTS = 'providerResults',
  CONSOLIDATED_CARE_NAVIGATOR = 'consolidatedCareNavigator',
  ENHANCED_ZERO_RESULTS = 'enhancedZeroResults',
}

export enum CARELON_PROVIDER_DIRECTORY_TREATMENT_GROUPS {
  OUTPATIENT_THERAPY = 'outpatientTherapy',
  MEDICATION_MANAGEMENT = 'medicationManagement',
}

// Domain keys are mapped from LaunchDarkly values at the application boundary.
export enum CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS {
  OUTPATIENT_THERAPY = 'outpatientTherapy',
}

export const EMPTY_CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS: CarelonProviderDirectoryFeatureFlagValues = {}

// Add an entry for each Carelon placement with its fixed view and click properties
// Visibility and selected-treatment properties are added by the helpers in mixpanelUtils.ts
export const CARELON_DIRECTORY_TRACKING_CONFIG: Readonly<
  Record<CARELON_PROVIDER_DIRECTORY_PLACEMENTS, CarelonDirectoryTrackingConfiguration>
> = {
  [CARELON_PROVIDER_DIRECTORY_PLACEMENTS.PROVIDER_RESULTS]: {
    viewProperties: {},
    clickProperties: {
      [COMMON_MIXPANEL_PROPERTIES.PAGE]: COMMON_MIXPANEL_PAGE.PROVIDER_RESULTS,
    },
  },
  [CARELON_PROVIDER_DIRECTORY_PLACEMENTS.CONSOLIDATED_CARE_NAVIGATOR]: {
    viewProperties: {
      [COMMON_MIXPANEL_PROPERTIES.PAGE]: COMMON_MIXPANEL_PAGE.ZERO_RESULTS,
    },
    clickProperties: {
      [COMMON_MIXPANEL_PROPERTIES.PAGE]: COMMON_MIXPANEL_PAGE.GENERAL_CN_CONTACT_PAGE,
      [S4C_PROPERTIES.CN_entrypoint]: COMMON_MIXPANEL_PAGE.ZERO_RESULTS,
    },
  },
  [CARELON_PROVIDER_DIRECTORY_PLACEMENTS.ENHANCED_ZERO_RESULTS]: {
    viewProperties: {
      [COMMON_MIXPANEL_PROPERTIES.PAGE]: COMMON_MIXPANEL_PAGE.ZERO_RESULTS,
    },
    clickProperties: {
      [COMMON_MIXPANEL_PROPERTIES.PAGE]: COMMON_MIXPANEL_PAGE.GENERAL_CN_CONTACT_PAGE,
      [S4C_PROPERTIES.CN_entrypoint]: COMMON_MIXPANEL_PAGE.ZERO_RESULTS,
    },
  },
}
